import angular from 'angular';

import component from './syncWindowSelector.component';

// Dependencies
import logServiceModule from '../../service/LogService';
import translationServiceModule from '../../service/TranslationService';
import confirmModalModule from '../modals/confirmModal';
import uiBootstrapDropdownModuleName from 'angular-ui-bootstrap/src/dropdown'


let module = angular.module('recaps.components.syncWindowSelector', [
  logServiceModule.name,
  translationServiceModule.name,
  confirmModalModule.name,
  uiBootstrapDropdownModuleName,
]);

module.component('syncWindowSelector', component);

export default module;
